import { Injectable } from '@angular/core';
import { RemoteConfigService } from '../remote-config/remote-config.service';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

  siteKey = "";
  constructor(private remoteConfigService: RemoteConfigService) {
    this.remoteConfigService.getKeySite().subscribe(key => {
      this.siteKey = key;
    })
   }

  async render(id){
    return new Promise((resolve, reject) => {
      window['grecaptcha'].render(id, {
        'sitekey': this.siteKey,
        'size': 'invisible'
      });
      window['grecaptcha'].execute().then(token => resolve(token));
      window['grecaptcha'].ready(() => {
        window['grecaptcha'].reset();
      })
    })
  }


}
